<template>
  <div class="faults">
    <div class="filters">

      <span class="p-input-icon-left">
        <i class="pi pi-filter" />
        <InputText type="text" v-model="filterText" placeholder="Filter" />
      </span>
    </div>
    <div class="fault_list">
      <div class="fault" v-for="f in filteredFaults" :key="f.id">
        <div class="p-d-flex p-jc-center">
          <div class="p-px-3">
            <h3 class="p-m-2">{{ f.admin }}</h3>
          </div>

          <div class="techstatus p-px-3">
            <h3 class="p-m-2">{{ f.techstatus }}</h3>
          </div>
        </div> 

        <div class="desc">
          <h3 class="p-text-uppercase p-m-0">{{ f.desc }}</h3>
        </div>

        <div class="item">
          <div>Status:</div>
          <b v-if="f.status">{{ f.status }}</b>
        </div>

        <div class="created item">
          <div>Date Reported:</div>
          <b>{{ formatDate(f.created) }}</b>
        </div>

        <div class="mechanic item">
          <div>Verified by:</div>
          <b v-if="f.mechanic"
            >{{ f.mechanic.rank }} {{ f.mechanic.lastname }},
            {{ f.mechanic.firstname }}
          </b>
          <b v-else class="assigned item">Not assigned</b>
        </div>

        <div class="repairstatus item">
          <div>Status of Repair:</div>
          <b class="assigned item">{{ f.repairstatus || "..." }}</b>
        </div>




        <Button
          type="button"
          label="Mark As Complete!"
          icon="pi pi-check-circle"
          class="p-button-warning p-mb-3"
          @click="confirmSubmit(f)"
        />



        <Dialog
          header="Warning"
          :visible="confirmSubmitDialog"
          :style="{ width: '350px' }"
          :modal="true"
        >
          <div class="confirmation-content">
            <i
              class="pi pi-exclamation-triangle p-mr-3"
              style="font-size: 2rem"
            />
            <span><b>THIS CANNOT BE UNDONE!</b><br/><br/>
            Only confirm yes if you have created this notification in GCSS-Army</span><br/><br/>
            Would you like to complete this PMCSx Fault?
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              @click="confirmSubmitDialog = false"
              class="p-button-text"
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              @click="submitFault()"
              class="p-button-text"
              autofocus
            />
          </template>
        </Dialog>







      </div>
    </div>
  </div>
</template>

<script>
import { fb_db, fs, fb_auth, } from "../firebase";
import { format } from "date-fns";

import Dialog from "primevue/dialog";

export default {
  name: "NewFaults",
  components: {
    Dialog,

  },
  data() {
    return {
      faults: [],
      confirmSubmitDialog: false,
      filterText: "",
      selectedStatus: "Needs Entered In GCSS",
      form: {
        admin: null,
        techstatus: null,
        desc: null,
        created: null,
        mechanic: null,
        status: null,
        user: null,
      },
    };
  },
  async mounted() {
    await this.getFaults();
        this.loading = false;
  },
  methods: {
    async getFaults() {
      this.loading = true;
      let userRef = await fb_db.collection("users").doc(fb_auth.currentUser.uid).get()
      let user = userRef.data()
      await fb_db
        .collection("faults").orderBy("admin").where("puic", "==", user.puic)
        .where("status", "==", "Needs Entered In GCSS")
        .get()
        .then((docs) => {
          this.faults = [];
          docs.forEach(async (doc) => {
            let item = doc.data();
            item.id = doc.id;
            let user = await item.user.get();
            item.user = user.data();
            if (item.mechanic) {
              console.debug("loading mech");
              let mech = await item.mechanic.get();
              item.mechanic = mech.data();
            }
            this.faults.push(item);
          });
          this.loading = false;
        })
        .catch((error) => {
          console.error("error getting faults: ", error);
        });
    },
    formatDate(date) {
      let dt = date.toDate();
      return format(dt, "HH:mm MM/DD/YYYY");
    },
        confirmSubmit(fault) {
      console.log("confirm submit");
      this.submitthisfault=fault
      this.confirmSubmitDialog = true;
    },
        submitFault() {
        console.log("Submit fault: ", this.submitthisfault.id);
        fb_db
          .collection("faults")
          .doc(this.submitthisfault.id)
          .update({
            status: "Complete"
          })
          .then(() => {
            console.log("Fault successfully submitted");
            this.confirmSubmitDialog = null;
            this.getFaults();
          })
          .catch((error) => {
            this.$toast.add({
              severity: "error",
              summary: "Error!",
              detail: error,
              life: 3000,
            });
            console.error("error submitting Fault: ", error);
          });
    },
  },
  computed: {
    filteredFaults() {
      return this.faults.filter((f) => {
if (this.selectedStatus == "Needs Entered In GCSS") {
          return (
            f.status == "Needs Entered In GCSS" &&
            f.admin.toLowerCase().indexOf(this.filterText.toLowerCase()) > -1
          );
        } 
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/theme.scss";

.faults {
  .fault_list {
    .fault {
      width: 300px;

      background: #efefef;
      border-radius: 10px;
      margin: 10px;
      float: left;

      div {
        margin: 0px 5px;
        padding: 5px 15px;
        border-radius: 5px;
        // color: $white;
      }

      .edit {
        background: $accent;
        // color: $text;
        cursor: pointer;
      }

      .submit {
        background: $primary;
        // color: $white;
        cursor: pointer;
      }

      .item {
        padding: 5px;
        text-align: left;

        b {
          margin-left: 25px;
        }

        div {
          font-size: 14px;
        }
      }

      .admin {
      }

      .niin {
        color: black;
      }

      .desc {
        color: #000000;
      }

      .qty {
                color: black;
      }

      .repairstatus {

      }

      .created {
      }

      .mechanic {
        color: black;
      }

      .assigned {
        color: red;
      }
    }
  }
}
</style>